import React, { useState } from 'react';
import Table from '../../layout/forms/Table'
import { useEffect } from 'react';
import apiObjectDocumentLinks from '../../../api/objectDocumentLinks';

const DocumentLinks = ({ selectedGlobalObjectKey }) => {
    const [documentLinks, setDocumentLink] = useState([]);

    useEffect(() => {
        if (selectedGlobalObjectKey === null) {
            setDocumentLink([]);
            return;
        }
        const reloadDocumentLink = async () => {
            const dataDocumentLink = await apiObjectDocumentLinks.get(
                selectedGlobalObjectKey
            );
            setDocumentLink(dataDocumentLink);
        }
        reloadDocumentLink();
    }, [selectedGlobalObjectKey]);
    return (
        <Table title="Document Links"
            rowsPerPage={100}
            columns={[
                { title: 'Document Title', field: 'documentTitle', width: 200 },
                { title: 'ObjectName', field: 'objectName', width: 200 },
                { title: 'Link KEY', field: 'linkKEY', width: 200 },

            ]}data = {documentLinks} />
        );
};
export default DocumentLinks;


